import TimeFormatSettings from '@/util/TimeFormatSettings'

export default {
  state: {
    locale: undefined,
    translationStrings: {},
    timeFormatSettings: TimeFormatSettings,
    localeLoadedWithVersion: undefined
  },

  getters: {

    locale: state => {
      return state.locale
    },

    localLoaded: state => {
      return state.locale !== undefined
    },

    translationStrings: state => {
      return state.translationStrings[state.locale]
    },

    translationsLoaded: (state, getters, rootState, rootGetters) => {
      // We use web sockets to push down updates when the app is updated or
      // translations change, etc... but it's possible (even likely) this client
      // wasn't active during that event and so we need to verify here if we're
      // up to date.
      if (state.localeLoadedWithVersion !== rootGetters['appMetadataModule/version']) {
        return false
      }

      return state.translationStrings[state.locale] !== undefined
    }
  },

  mutations: {

    /**
     * Sets the desired locale on the state
     *
     * @param {Object} state
     * @param {String} locale e.g. en or en-US
     */
    setLocale (state, locale) {
      state.locale = locale
    },

    /**
     * Updates the store with the translations provided
     *
     * @param {Object} state
     * @param {Object} translations Object with translation strings and the
     * version of the app at the time they were set.
     */
    setTranslationStrings (state, translations) {
      // If the app version has changed since we last loaded locale strings
      // invalidate all locale strings and update the localeLoadedWithVersion to
      // the new version
      if (state.localeLoadedWithVersion !== translations.version) {
        state.translationStrings = {}
        state.localeLoadedWithVersion = translations.version
      }

      state.translationStrings[state.locale] = translations.strings
    },

    /**
     * Removes all existing translation strings stored on this state
     *
     * @param {Object} state
     * @param {String} localeToKeep when set this locale will not be cleared
     * out. This is useful for "hot updates" of the local where we want to
     * revoke the stored state but don't want any "flicker" as new translations
     * are loaded. Using this param we can keep one specific locale in state
     * (wiping out all others) and then replace just that one locale when we get
     * it from the server.
     */
    clearTranslationStrings (state, localeToKeep = null) {
      if (localeToKeep) {
        const newTranslationStrings = {}
        newTranslationStrings[localeToKeep] = state.translationStrings[localeToKeep]
        state.translationStrings = newTranslationStrings
      } else {
        state.translationStrings = {}
      }
    },

    /**
     * Sets the time format preferences on the state
     *
     * @param {Object} state
     * @param {Object} timeFormatSettings contains the user's time format
     * preferences (see util/TimeFormatSettings )
     */
    setTimeFormatSettings (state, timeFormatSettings) {
      state.timeFormatSettings = timeFormatSettings
    }
  },

  actions: {

    setLocale (context, locale) {
      context.commit('setLocale', locale)
    },

    setTranslationStrings (context, strings) {
      context.commit('setTranslationStrings', {
        version: context.rootGetters['appMetadataModule/version'],
        strings: strings
      })
    },

    clearTranslationStrings (context, localeToKeep) {
      context.commit('clearTranslationStrings', localeToKeep)
    },

    setTimeFormatSettings (context, timeFormatSettings) {
      context.commit('setTimeFormatSettings', timeFormatSettings)
    }
  }

}
